/**
 * A marca do personal guardada no APARELHO, e como apagá-la.
 *
 * O que fica guardado: a cor (com as superfícies derivadas), o logo escuro, o
 * logo claro, o nome ao lado do logo e a escala. Elas existem para o app não
 * abrir sem marca e piscar a nossa antes da resposta da API.
 *
 * Vive num arquivo próprio porque a lista já divergiu em dois lugares: o logout
 * apagava três das cinco chaves, e o logo claro e a escala do personal anterior
 * continuavam no celular, aparecendo para quem entrasse depois no mesmo
 * aparelho. Um lugar só, e quem precisa limpar chama.
 *
 * Quem manda apagar:
 *
 * - o `BrandThemeProvider`, quando a API responde `personalizacao_ativa: false`
 *   (o personal caiu para um plano sem a funcionalidade) ou quando a conta não
 *   tem tema nenhum;
 * - o logout, porque o próximo a entrar pode ser aluno de outro personal.
 */
/** A cor guardada. Separada porque a casca a consulta para decidir se espera a API. */
export const CHAVE_TEMA_DA_MARCA = "wt_brand_theme"

export const CHAVES_DA_MARCA_NO_APARELHO = [
  CHAVE_TEMA_DA_MARCA,
  "wt_brand_logo",
  "wt_brand_logo_light",
  "wt_brand_logo_titulo",
  "wt_brand_logo_escala",
] as const

/** Apaga a marca guardada. É o que faz o aluno voltar a ver o Welltrainer. */
export function limparMarcaDoAparelho() {
  try {
    for (const chave of CHAVES_DA_MARCA_NO_APARELHO) localStorage.removeItem(chave)
  } catch {
    /* Janela privada ou site com dado bloqueado: não há o que limpar. */
  }
}
